import { render } from "./RfqsIndex.vue?vue&type=template&id=d584d702"
import script from "./RfqsIndex.vue?vue&type=script&lang=js"
export * from "./RfqsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__